// extracted by mini-css-extract-plugin
module.exports = {"container":"Item_container__1yQV5","playerCounts":"Item_playerCounts__OGkZO","description":"Item_description__q_WSi"};